import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';

@Component({
  selector: 'app-permissions-dialog',
  template: `
    <h2 mat-dialog-title>Edit Permissions</h2>
    <mat-dialog-content>
      <p><strong>{{ data.firstName }} {{ data.lastName }}</strong></p>
      <mat-checkbox [(ngModel)]="data.permissions.viewConversations">
        View Conversations
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="data.permissions.sendMessages">
        Send Messages
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="data.permissions.viewInsights">
        View Insights
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="data.permissions.manageUsers">
        Manage Users
      </mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onSave()">Save</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-checkbox { display: block; margin: 10px 0; }
    mat-dialog-actions {gap: 1rem;}
  `],
  standalone:true,
  imports:[CommonModule, FormsModule,MatDialogTitle, MatDialogContent,MatCheckbox,MatDialogActions]
})
export class PermissionsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PermissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.data);
  }
}